import { FC, useState } from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { AxiosError } from 'axios';
import { ReactComponent as StartIcon } from 'assets/icons/start-icon.svg';
import dayjs from 'dayjs';
import { IErrorResponse } from 'types';
import { CustomDatePicker } from 'components/elements';
import toastService from 'components/elements/Toastify';
import { getErrorMessage } from 'utils/helpers';
import { ReportsService } from 'utils/services';
import styles from './index.module.scss';

const SUCCESS_MESSAGE = 'Розпочато створення звітів Portmone та перегляд рахунків';

export const PortmoneRevision: FC = () => {
	const [revisionDate, setRevisionDate] = useState<Date | null>(() => new Date());
	const [isLoading, setIsLoading] = useState(false);

	const handleRevision = async () => {
		if (!revisionDate) return;

		try {
			setIsLoading(true);
			const response = await ReportsService.revisePortmoneSummary({
				revisionDate: dayjs(revisionDate).format('YYYY-MM-DD'),
			});

			if (response.status === 201) {
				toastService.success(SUCCESS_MESSAGE);
			} else {
				toastService.error(response.data);
			}
		} catch (error) {
			toastService.error(getErrorMessage(error as AxiosError<IErrorResponse>));
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<Box className={styles.section}>
			<Box className={styles.content}>
				<Typography variant="h4">Звірка Portmone</Typography>
				<Typography variant="body2" color="common.textLightGray">
					Оберіть дату проведення платежів
				</Typography>
				<Box className={styles.controls}>
					<CustomDatePicker
						name="revisionDate"
						views={['year', 'month', 'day']}
						format="DD.MM.YYYY"
						initialDate={revisionDate}
						className={styles.datePicker}
						onChange={setRevisionDate}
					/>
					<Button
						variant="outlined"
						color="primary"
						className={styles.action}
						startIcon={!isLoading && <StartIcon opacity={revisionDate ? 1 : 0.3} />}
						disabled={!revisionDate || isLoading}
						onClick={() => {
							void handleRevision();
						}}
					>
						{isLoading ? <CircularProgress size={20} color="success" /> : 'Розпочати звірку'}
					</Button>
				</Box>
			</Box>
		</Box>
	);
};
